import * as React from 'react'
import {inject, observer} from 'mobx-react'
import CustomModal from 'src/components/containers/CustomModal'
import {StoreProps} from 'src/stores'
import styled from 'styled-components'
import {media} from 'src/utils.js'
import {RadioButton, RadioGroup} from '../../atoms/input/RadioButton'
import TextInput from '../../atoms/input/TextInput'
import Footer from '../../atoms/wizard/Footer'

import FormContainer from '../../containers/FormContainer'
import {ContactDetailInput} from '../../../resources'
import {StartBtn} from '../../atoms/input/buttons'

const stefan = require('src/assets/redesign/Stefan_Atz.png')
const trustedShops = require('src/assets/redesign/trusted_shops_logo.png')
const google = require('src/assets/configurator/google_reviews.png')
const sslShield = require('src/assets/redesign/ssl_shield.png')
const sslLock = require('src/assets/wizard/lock_SSL.png')

interface State {
  contactDetails: ContactDetailInput
}

@inject('confStore')
@observer
export default class ContactDetailsPopup extends React.Component<
  StoreProps,
  State
> {
  constructor(props) {
    super(props)
    const { confStore } = this.props
    this.state = {
      contactDetails: confStore.getOffer.contactDetails
    }
  }

  componentDidMount() {
    const { confStore } = this.props
    if (confStore.isContactDetailsMissing) {
      confStore.setContactDetailsPopup(true)
    }
    window.dataLayer.push({ event: 'optimize.detailplanung' })
  }

  componentDidUpdate() {
    window.dataLayer.push({ event: 'optimize.detailplanung' })
  }

  isContactDetailsMissing = () => {
    const { confStore } = this.props
    return confStore.getOffer.contactDetails.firstName === ''
  }

  setGreeting = (e) => {
    const { contactDetails } = this.state
    contactDetails.greeting = e.target.value
    this.setState({ contactDetails })
  }

  setFirstname = (e) => {
    const { contactDetails } = this.state
    contactDetails.firstName = e
    this.setState({ contactDetails })
  }

  setLastname = (e) => {
    const { contactDetails } = this.state
    contactDetails.lastName = e
    this.setState({ contactDetails })
  }

  setEmail = (e) => {
    const { contactDetails } = this.state
    contactDetails.email = e
    this.setState({ contactDetails })
  }

  setPhone = (e) => {
    const { contactDetails } = this.state
    contactDetails.phone = e
    this.setState({ contactDetails })
  }

  validEmail = (email) => {
    if (
      email &&
      email.length > 4 &&
      email.split('@').length === 2 &&
      email.includes('.') &&
      (email.indexOf(' ') === email.length - 1 || email.indexOf(' ') === -1)
    )
      return true
    return false
  }

  validName = (name) => {
    return name && name.length > 0 && !/\d/.test(name)
  }

  validPhone = (phone) => {
    return phone && phone.length > 5 && !!parseFloat(phone)
  }

  validForm = () => {
    const { contactDetails } = this.state
    return (
      this.validEmail(contactDetails.email) &&
      this.validName(contactDetails.firstName) &&
      this.validName(contactDetails.lastName) &&
      this.validPhone(contactDetails.phone)
    )
  }

  handleClose = () => {
    const { confStore } = this.props
    confStore.setContactDetailsPopup(false)
  }

  submit = () => {
    const { confStore } = this.props
    const { contactDetails } = this.state
    confStore.setOfferContactDetails(contactDetails, () => {
      confStore.setContactDetailsPopup(false)
    })
  }

  contactForm = () => {
    const { contactDetails } = this.state
    return (
      <>
        <p>
          Wir senden Ihnen <strong>kostenfrei und 
          völlig unverbindlich</strong> ein komplettes Angebot mit 
          allen Kosten zu. An wen dürfen wir das Angebot senden?
        </p>
        <CustomFormContainer>
          <CustomRadioGroup>
            <RadioButton
              name='gender'
              label='Herr'
              value='MR'
              onClick={this.setGreeting}
              defaultChecked={contactDetails.greeting === 'MR'}
              inline
            />
            <RadioButton
              name='gender'
              label='Frau'
              value='MRS'
              onClick={this.setGreeting}
              defaultChecked={contactDetails.greeting === 'MRS'}
              inline
            />
          </CustomRadioGroup>
          <TextFieldContainer>
            <TextInput
              value={contactDetails.firstName}
              name='firstname'
              placeholder='Vorname *'
              onChange={this.setFirstname}
              validate={this.validName}
            />
            <TextInput
              value={contactDetails.lastName}
              name='lastname'
              placeholder='Nachname *'
              onChange={this.setLastname}
              validate={this.validName}
            />
            <TextInput
              value={contactDetails.email}
              name='email'
              placeholder='E-Mail *'
              onChange={this.setEmail}
              validate={this.validEmail}
            />
            <TextInput
              value={contactDetails.phone}
              name='phone'
              placeholder='Telefon *'
              type='tel'
              onChange={this.setPhone}
              validate={this.validPhone}
            />
          </TextFieldContainer>
          <p>* Pflichtfeld</p>
        </CustomFormContainer>
        <Footer style={{ background: 'white' }}>
          <img src={sslLock} alt='sslLock' style={{ marginRight: '10px' }} />
          <p style={{ fontSize: '12px', margin: 0 }}>
            Ihre Kontaktdaten werden{' '}
            <strong>ausschließlich für Ihre Beratung</strong> verwendet. Sie
            erlkären sich damit einverstanden, dass Benu Sie telefonisch und per
            E-Mail kontaktiert.
          </p>
        </Footer>
        <ButtonContainer>
          <StartBtn
            name='submit'
            style={{ height: 'unset', width: 'unset', minWidth: '12em' }}
            onClick={this.submit}
            disabled={!this.validForm()}>
            ANGEBOT ERHALTEN
          </StartBtn>
        </ButtonContainer>
        <StefanContainer>
          <ProfilePicture
            src={stefan}
            height={120}
            width={120}
            alt='Stefan Atz'
          />
          <p>
            <i>
              „Mein Team an Bestattungs&shy;experten und ich kümmern uns
              persönlich um alle Ihre Anliegen.”
            </i>
            <br />
            <br />
            <strong>Stefan Atz</strong>
            <br />
            <i>(Geschäftsführer)</i>
          </p>
        </StefanContainer>
        <ImagesContainer>
          <img src={google} alt='google' />
          <img src={trustedShops} alt='trusted_shops' />
          <img src={sslShield} alt='ssl_shield' />
        </ImagesContainer>
      </>
    )
  }

  render() {
    const { confStore } = this.props

    return (
      <CustomModal
        title='Unverbindliches Angebot erhalten'
        open={confStore.showContactDetailsPopup}
        onClose={this.handleClose}
        cancelX
        hideCloseButton>
        <div style={{ textAlign: 'left' }}>{this.contactForm()}</div>
      </CustomModal>
    )
  }
}

const CustomFormContainer = styled(FormContainer)`
  margin: 15px auto;
  padding: 0;
`

const CustomRadioGroup = styled(RadioGroup)`
  ${media.tablet` align-self: unset; `}
`

const TextFieldContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;

  ${media.tablet`
    grid-template-columns: 1fr;
    div {
      width: 100%;
    }
  `}
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
`

const StefanContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 7.5px 15px;
  background: #d5e4e6;

  * {
    margin: 15px;
  }

  p {
    line-height: 1.15;
    * {
      margin: 0;
    }
  }
  ${media.tablet`
    flex-direction: column;
    p {
      text-align: center;
    }
  `}
`

const ProfilePicture = styled.img`
  display: block;
  margin: 15px auto;
  border-radius: 100%;
  box-shadow: 2.5px 2.5px 5px rgb(74, 74, 74);
  flex-shrink: 0;
`

const ImagesContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 15px 0;
  img {
    max-width: 100px;
    max-height: 70px;
    margin: auto;
    padding: 0 7.5px;
  }
`



// WEBPACK FOOTER //
// ./src/components/organisms/configurator/ContactDetailsPopup.tsx